<template>
  <CCard>
    <CCardHeader class="border-0 px-4 pb-1 pt-4">
      <div class="d-flex align-items-center font-weight-medium">
        <CIcon name="cipGridSm" size="custom-size" :width="18" class="mr-2"/>
        <translate translate-context="accounting.order">Movimenti contabili</translate>
        <CButton
          color="link"
          size="sm"
          class="ml-2 p-0 explain-btn"
          @click="openExplanation"
          v-c-tooltip="{content: $pgettext('accounting.order', 'How are these calculated?'), placement: 'top'}"
        >
          <CIcon name="cipInfo" size="sm"/>
        </CButton>
      </div>
    </CCardHeader>
    <CCardBody>
      <div v-if="groups.length === 0" class="text-center py-4">
        <CIcon name="cipXCircle" size="xl" class="mb-2"/>
        <p class="mb-0">
          <translate translate-context="accounting.ledger">No ledger entries found</translate>
        </p>
      </div>
      <div
        v-for="(group, idx) in groups"
        :key="group.key"
        class="ledger-group"
        :class="{ 'mt-4': idx > 0 }"
      >
        <div class="ledger-group__header">
          <template v-if="group.type === 'order_item'">
            <span class="font-weight-medium mr-2">
              {{ group.item.pica_service_name || `Order item #${group.item.id}` }}
            </span>
            <code v-if="group.item.picacode" class="picacode-tag mr-2">
              <CIcon name="cil-qr-code" size="sm" class="mr-1"/>{{ group.item.picacode }}
            </code>
            <span class="text-muted small">#{{ group.item.id }}</span>
          </template>
          <template v-else>
            <CIcon name="cil-globe-alt" size="sm" class="mr-2"/>
            <span class="font-weight-medium">
              <translate translate-context="accounting.order">Movimenti globali ordine</translate>
            </span>
          </template>
        </div>
        <LedgerEntriesTable :entries="group.entries" bare/>
      </div>
    </CCardBody>
    <OrderLedgerExplanationModal ref="explanationModal"/>
  </CCard>
</template>

<script>
import LedgerEntriesTable from '../../components/LedgerEntriesTable.vue'
import OrderLedgerExplanationModal from './OrderLedgerExplanationModal.vue'
import {sortEntriesByStakeholder} from '../../constants'

export default {
  name: 'OrderLedgerEntries',
  components: {LedgerEntriesTable, OrderLedgerExplanationModal},
  props: {
    entries: {
      type: Array,
      default: () => []
    },
    orderItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    groups() {
      const byItemId = new Map()
      const globalEntries = []

      for (const entry of this.entries) {
        if (entry.source_type === 'order_item' && entry.source_id) {
          if (!byItemId.has(entry.source_id)) {
            byItemId.set(entry.source_id, [])
          }
          byItemId.get(entry.source_id).push(entry)
        } else {
          globalEntries.push(entry)
        }
      }

      const result = []

      for (const item of this.orderItems) {
        if (byItemId.has(item.id)) {
          result.push({
            key: `item-${item.id}`,
            type: 'order_item',
            item,
            entries: sortEntriesByStakeholder(byItemId.get(item.id))
          })
          byItemId.delete(item.id)
        }
      }

      for (const [itemId, entries] of byItemId.entries()) {
        result.push({
          key: `item-${itemId}`,
          type: 'order_item',
          item: {id: itemId},
          entries: sortEntriesByStakeholder(entries)
        })
      }

      if (globalEntries.length) {
        result.push({
          key: 'global',
          type: 'global',
          entries: sortEntriesByStakeholder(globalEntries)
        })
      }

      return result
    }
  },
  methods: {
    openExplanation() {
      this.$refs.explanationModal.open()
    }
  }
}
</script>

<style scoped>
.ledger-group__header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 0;
  margin-bottom: 6px;
  border-bottom: 1px solid #e4e7ea;
}

.picacode-tag {
  background: #f4f6f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.8rem;
}
</style>
